/**
 * Microsoft Clarity Configuration
 * @see {@link https://clarity.microsoft.com/}
 */

import clarity from "@microsoft/clarity";

const CLARITY_PROJECT_ID = "u0eviok7ja";

type InitClarityOptions = {
  enabled?: boolean;
};

const initClarity = (options?: InitClarityOptions) => {
  if (options?.enabled === false) return;

  clarity.init(CLARITY_PROJECT_ID);
};

export default initClarity;
